module.exports = __webpack_public_path__ + "img/faqs.c3702eb8.svg";